import CryptoJS from 'crypto-js'

function generateJwtToken(payload) {
  const base64url = (source) => {
    // Encode in classical base64
    let encodedSource = CryptoJS.enc.Base64.stringify(source);
  
    // Remove padding equal characters
    encodedSource = encodedSource.replace(/=+$/, '');
  
    // Replace characters according to base64url specifications
    encodedSource = encodedSource.replace(/\+/g, '-');
    encodedSource = encodedSource.replace(/\//g, '_');
  
    return encodedSource;
  }

  const header = {
    "alg": "HS256",
    "typ": "JWT",
  }

  let stringifiedHeader = CryptoJS.enc.Utf8.parse(JSON.stringify(header));
  let encodedHeader = base64url(stringifiedHeader);

  const data = payload

  let stringifiedData = CryptoJS.enc.Utf8.parse(JSON.stringify(data));
  let encodedData = base64url(stringifiedData);
  let unsignedToken = encodedHeader + "." + encodedData;
  let secret = "aG5ha0pXVEF1dGhTZWNyZXRLZXk="
  let signature = CryptoJS.HmacSHA256(unsignedToken, secret)
  signature = base64url(signature)
  let signedToken = unsignedToken + "." + signature;

  return signedToken
}

export default generateJwtToken